import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    background-color: ${vars.backgroundMain};
    min-height: 50vh;
    padding: 0 0 10em 0;

    .policy-privacy {
        padding: 2em 0 0 0;

        .policy-privacy-data {
            margin-top: 2em;
            padding: 4em 10em;
            background-color: ${vars.colorSecondary};
            border-radius: 0.3em;

            h1,
            h2,
            h3,
            p {
                color: ${vars.colorTextWhite};
            }

            .policy-privacy-top-bar {
                width: 100%;
                height: 4em;
                display: flex;
                margin-bottom: 2em;
                border-radius: 0.5em;

                &__users {
                    border-radius: 0.5em 0 0 0.5em;
                }

                &__partners {
                    border-radius: 0 0.5em 0.5em 0;
                }


                &__users,
                &__partners {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex: 1 100%;
                    color: ${vars.colorTextWhite};
                    font-size: 1.2em;
                    border: 2px solid ${vars.colorSelectHover};
                    transition: border-color 200ms ease;

                    &.active {
                        font-weight: bold;
                        background: ${vars.backgroundGradient250};
                    }

                    &:not(.active) {
                        cursor: pointer;

                        @media (pointer: fine) {
                            &:hover {
                                border-color: ${vars.colorViolet};
                            }
                        }
                    }
                }
            }

            .policy-privacy-header {
                margin: 0 0 2em 0;

                .layout-button {
                    &.desktop {
                        display: flex;
                    }

                    &.mobile {
                        display: none;
                    }
                }

                .policy-privacy-header-headline {
                    font-size: 3em;
                }
            }

            .policy-private-content-container {
                width: 100%;
                min-height: 1000px;
                height: 80vh;

                iframe {
                    border: none;
                    width: 100%;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        .policy-privacy {
            .policy-privacy-data {
                padding: 3em;

                .policy-privacy-header {
                    .layout-button {
                        &.desktop {
                            display: none;
                        }

                        &.mobile {
                            display: flex;
                        }

                        .button {
                            height: unset;
                            padding: 1em
                        }
                    }

                    .policy-privacy-header-headline {
                        font-size: 1.9em;
                        text-align: center;
                        margin-bottom: 1em;
                    }
                }

                .policy-private-content-container {
                    display: none;
                }
            }
        }
    }
`;
